









import { Component, Vue, Prop, Emit } from 'vue-property-decorator'

@Component({
  name: 'ekko-viewable-image',
  components: { },
})
export default class EkkoViewableImage extends Vue {
  @Prop({ required: true }) src!: string
  @Prop({ default: '' }) alt!: string

  @Emit()
  viewImage() {
    return this.src
  }
}
